import "../sass/main.scss";
import CartItemsList from "./components/cartItemsList";

export { CartItemsList };
